import Breadcrumbs from './Breadcrumbs.connect';

export default Breadcrumbs;
